<template>
  <span class="badge badge-success" v-if="isFree()">Free</span>
  <span class="badge badge-danger" v-else-if="isPaid()">Paid</span>
  <span class="badge badge-warning" v-else-if="isTrial()">Trial {{duration}} days</span>
  <span class="badge badge-info" v-else-if="isRental()">Rental {{duration}} days</span>
</template>

<script>
export default {
  name: 'sale-option',
  props: ['codename', 'duration'],
  methods: {
    isFree () {
      return this.codename !== undefined && this.codename === 'PURCHASE_FREE'
    },
    isPaid () {
      return this.codename === undefined || this.codename === 'PURCHASE_PAID'
    },
    isTrial () {
      return this.codename !== undefined && this.codename.includes('TRIAL')
    },
    isRental () {
      return this.codename !== undefined && this.codename.includes('RENTAL')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SaleOption.vue